<template>
   <v-alert type="error" dismissible @input="onClose" :value="true">
      {{ text }}
    </v-alert>
</template>

<script>
export default {
  name: 'AlertComponent',
  props: ['text'],
  methods: {
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/AlertComponent.vue